import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import language from '../../assets/languages/language';
import React from 'react';
class QuestionNotFoundModal extends React.Component {
  render() {
    const {
      alert_status,
      toggleAlert,
      MessageTitle,
      MessageContent,
    } = this.props;
    console.log('MessageTitle--->', MessageTitle);
    return (
      <Modal
        isOpen={alert_status}
        toggle={toggleAlert}
        className={'modal-primary ' + this.props.className}
      >
        <ModalHeader toggle={toggleAlert}>{MessageTitle}</ModalHeader>
        <ModalBody>
          <div className='d-flex flex-column'>
            <div> {MessageContent}</div>
            <div className='text-right'>
              {' '}
              <Button color='primary' onClick={toggleAlert}>
                {' '}
                {language.LC().OK}{' '}
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
export default QuestionNotFoundModal;



// WEBPACK FOOTER //
// ./src/views/Common/questionNotFoundModel.js